import React from 'react'
import PropTypes from 'prop-types'
import { Button, Modal } from '@resurs/midas-react'
import { midas } from '@resurs/midas'
import Conditional from '@resurs/react-utils/lib/components/Conditional'
import { getText } from '../../internal/TextLabels'
import { format } from '../../models/format'

class SendMailModalForm extends React.PureComponent {
  sendMail() {
    this.props.onSubmit()
    this.props.onClose()
  }

  keyPress(e) {
    const regex = new RegExp(format.email.regex)
    if (e.keyCode === 13 && regex.exec(e.target.value)) {
      this.sendMail()
    }
  }

  render() {
    return (
      <Modal
        show={this.props.show}
        title={
          !this.props.message
            ? getText('payApply.paymentDone.emailForSendingReceipt')
            : this.props.message
        }
        onClose={() => this.props.onClose()}
        hideClose
        actions={
          <>
            <Button
              type="link"
              onClick={() => this.props.onClose()}
              tabIndex={this.props.show ? 2 : -1}
            >
              {getText('default.cancel')}
            </Button>
            <Button
              onClick={() => this.sendMail()}
              disabled={this.props.disableInput}
              tabIndex={this.props.show ? 3 : -1}
            >
              {getText('payApply.paymentDone.send')}
            </Button>
          </>
        }
      >
        <div
          style={{
            display: 'inline-block',
            width: '100%',
            height: '50px',
          }}
        >
          <div className={midas.inputGroup}>
            <input
              id="send-purchase-email"
              className={midas.formInput}
              type="email"
              onChange={e => {
                this.props.onChange(e.target.value)
              }}
              tabIndex={this.props.show ? 1 : -1}
              onKeyDown={e => this.keyPress(e)}
              placeholder={getText('payApply.paymentDone.emailPlaceholder')}
              value={this.props.inputValue}
              disabled={this.props.disabled}
            />
          </div>
        </div>
        <Conditional when={this.props.disabled}>
          {getText('payApply.paymentDone.emailInfoWhenApplication')}
        </Conditional>
      </Modal>
    )
  }
}

SendMailModalForm.propTypes = {
  inputValue: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired,
  onClose: PropTypes.func.isRequired,
  disableInput: PropTypes.bool.isRequired,
  show: PropTypes.bool.isRequired,
  disabled: PropTypes.bool.isRequired,
  message: PropTypes.string,
}

SendMailModalForm.defaultProps = {
  message: '',
}

export default SendMailModalForm
